module.exports = __webpack_public_path__ + "img/select-template.320ec84e.png";